import { render, staticRenderFns } from "./iDropMenu.vue?vue&type=template&id=71b24dea&scoped=true&"
import script from "./iDropMenu.vue?vue&type=script&lang=js&"
export * from "./iDropMenu.vue?vue&type=script&lang=js&"
import style0 from "./iDropMenu.vue?vue&type=style&index=0&id=71b24dea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b24dea",
  null
  
)

export default component.exports